<template>
    <div id="page-member-dup-detail">
        <vx-card ref="filterCard" class="mb-1">
            <vs-row vs-w="12">
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6" >
                    <vs-input class="inputx" placeholder="Tài khoản" v-model="members"/>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="3" >
                    <vs-select v-model="dup">
                        <vs-select-item value="3" text="3"/>
                        <vs-select-item value="4" text="4"/>
                        <vs-select-item value="5" text="5"/>
                    </vs-select>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="3" >
                    <vs-input class="inputx" placeholder="stake" v-model="stake"/>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12" >
                    <date-range-picker 
                        @date-change="onDateFilterChange" 
                        :initDate="{from: fromDate, to: toDate}"
                        actionBtnText="Xem"
                    />
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                    <p style="font-size: 15px;">Total {{ total_bet }} bet</p>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" >
                    <ul class="centerx">
                        <li>
                            <vs-checkbox v-model="mem_choise_all">All</vs-checkbox>
                        </li>
                        <li :key="indexmem" v-for="(m, indexmem) in mem_count" style="float:left;">
                            <vs-checkbox v-model="mem_choise" :vs-value="m.mem">{{ m.mem+' ('+m.count+')' }}</vs-checkbox>
                        </li>
                    </ul>
                </vs-col>
            </vs-row>
        </vx-card>
        <div class="vx-card pl-5 pr-5">
                    <vs-row vs-w="12" vs-type="flex" vs-justify="space-between">
                        <vs-col vs-w="6" vs-type="flex">
                        </vs-col>
                    </vs-row>
                    <vs-row vs-w="12" vs-type="flex" vs-justify="space-between" style="margin-top: 10px;">
                    </vs-row>
            <vs-table 
                v-model="selected"
                :data="memberDupView"
            >
                <!-- <template slot="header"> -->
                <!-- </template> -->
                <template slot="thead">
                    <vs-th
                        :key="idx"
                        v-for="(h,idx) in header"
                    >
                        {{ h.title }}
                    </vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr 
                        :data="tr"
                        :class="tr.new_block == true ?'block_border':null" 
                        :key="indextr" 
                        v-for="(tr, indextr) in data">
                        <!-- <template v-if="tr.new_block">
                            <td class='td-line'></td>
                            <td class='td-line'></td>
                            <td class='td-line'></td>
                            <td class='td-line'></td>
                            <td class='td-line'></td>
                            <td class='td-line'></td>
                            <td class='td-line'></td>
                            <td class='td-line'></td>
                            <td class='td-line'></td>
                        </template>
                        <template v-else>  -->
                            <vs-td :key="idx" v-for="(h,idx) in header" :data="data[indextr][h.field]">
                                <p :class="tr.bet_key && h.field == 'member_name' ?'bet_key':null">
                                    <template v-if="h.render">
                                        {{ h.render(data[indextr]) }}
                                    </template>
                                    <template v-else>
                                        {{ data[indextr][h.field] }}
                                    </template>
                                </p>
                            </vs-td>
                        <!-- </template> -->
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import vSelect from 'vue-select';
import { AclRule } from 'vue-acl';
import numeral from 'numeral';
import moment from "moment";
import DateRangePicker from '@/components/DateRangePicker';

export default {
    data(){
        return {
            itemsPerPage: 100,
            header: [ 
                { title:"Member", field:"member_name", render: function(data){ return data.member_name.toUpperCase(); } },
                { title:"Ngày", field:"bet_time", render: function(data){ return moment(data.bet_time).format("DD-MM-YYYY|HH:mm:ss") } },
                { title:"IP", field:"bet_ip" },
                { title:"Sàn", field:"board_id", render: function(data){ return data.board_id == 1 ? "ibet" : data.board_id == 2 ? "sbo" : "unknown"; }},
                { title:"Chọn", field:"bet_choice", render: function(data){ return `${data.bet_choice} ${data.bet_handicap} ${data.bet_favorite}` } },
                { title:"Trận", field:"bet_match" },
                { title:"Loại", field:"bet_type" }, 
                { title:"Odds", field:"bet_odds" },
                { title:"Stake", field:"bet_stake" },
                { title:"Status", field:"bet_status" }
            ],
            memberDupAll: [],
            memberDupView: [],
            selected:[],
            members: "",
            stake: 100,
            dup: 3,
            mem_count: [],
            mem_choise: [],
            mem_choise_all: false,
            total_bet: 0,
            fromDate: moment().format("YYYY-MM-DD"),
            toDate: moment().format("YYYY-MM-DD")
        }
    },
    components: {
        vSelect,
        DateRangePicker
    },
    // computed: {
    //     fetchAccountWinlossPermission(){
    //         return new AclRule('store_account_info').generate();
    //     },
    // },
    watch:{
        mem_choise_all(newVal){
            let vm = this;
            if(newVal){
                let x = [];
                vm.mem_count.forEach(function(m, index){
                    x.push(m.mem);
                });

                vm.mem_choise = x;
            }else{
                vm.mem_choise = [];
            }
        },
        mem_choise(newVal){
            let all = [...this.memberDupAll];

            let res = [];
            let block = [];
            let hasValue = false;

            all.forEach(function(bet, index){
                let new_bet = {...bet};

                new_bet.new_block = false;

                if(new_bet.bet_key){
                    if(block.length == 0){
                        new_bet.new_block = true;
                    }
                    block.push(new_bet);
                }
                if(newVal.indexOf(new_bet.member_name) >= 0){
                    if(block.length == 0){
                        new_bet.new_block = true;
                    }
                    block.push(new_bet);
                    hasValue = true;
                }

                if((all[index+1] && all[index+1].new_block) || all.length == (index +1)){
                    if(hasValue){
                        res = res.concat(block);
                    }

                    block = [];
                    hasValue = false;
                }
            });
            this.memberDupView = res;
        }
    },
    methods:{
        fetchWinloss() {
            // if(this.$acl.not.check('fetchAccountWinlossPermission')) return;

            let vm = this;
            let payload = {
                "member_name": this.members,
                "stake": this.stake,
                "dup": this.dup,
                "from": this.fromDate,
                "to": this.toDate
            };

            this.$http.post('bets/member_dup', payload).then((res) => {
                const data = res.data.data;
                
                vm.memberDupAll = data.data;
                // vm.memberDupView = data.data;
                vm.mem_count = data.count;
                vm.total_bet = data.total_bet;
                // vm.mem_choise_all = true;
            });
        },
        onDateFilterChange(data){
            this.fromDate = data.fromDate;
            this.toDate = data.toDate;

            this.fetchWinloss();
        },
        // handleSelected(tr) {
        //     if(tr.bet_key){
        //         this.memberDupView = this.memberDupAll;
        //     }else{
        //         let all = [...this.memberDupAll];
        //         let res = [];
        //         let block = [];
        //         let hasValue = false;

        //         all.forEach(function(bet, index){
        //             let new_bet = {...bet};

        //             new_bet.new_block = false;

        //             if(new_bet.bet_key){
        //                 if(block.length == 0){
        //                     new_bet.new_block = true;
        //                 }
        //                 block.push(new_bet);
        //             }
        //             if(new_bet.member_name == tr.member_name){
        //                 if(block.length == 0){
        //                     new_bet.new_block = true;
        //                 }
        //                 block.push(new_bet);
        //                 hasValue = true;
        //             }

        //             if((all[index+1] && all[index+1].new_block) || all.length == (index +1)){
        //                 if(hasValue){
        //                     res = res.concat(block);
        //                 }

        //                 block = [];
        //                 hasValue = false;
        //             }
        //         });
        //         this.memberDupView = res;
        //     }
        // },
    },
};
</script>

<style lang="css">
.swal2-container{
    z-index: 99999;
}
#page-member-dup-detail .block_border{
    border-top: 10px solid #ddd;
}
#page-member-dup-detail .bet_key{
    color: rgb(255, 71, 87);
}
.td-line{
    padding: 0px !important;
}
</style>
